"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getxLogP3 = void 0;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the xLogP3 of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data
 */
function getxLogP3(data) {
    const xLogP3 = (0, getNumberProperties_1.getNumberProperties)(data, 'XLogP3');
    return xLogP3;
}
exports.getxLogP3 = getxLogP3;
//# sourceMappingURL=getxLogP3.js.map